const map = {
	"./CalculationSettings.js": 2805,
	"./Dashboard.js": 4981,
	"./FRMSSettings.js": 2631,
	"./FrmAPCreditNote.js": 9266,
	"./FrmAPInvoiceService.js": 1845,
	"./FrmAPInvoice_MBC.js": 8283,
	"./FrmDebitNotePurchase.js": 1997,
	"./FrmGRN_Challan.js": 8647,
	"./FrmGRN_PO.js": 2533,
	"./FrmPOService.js": 2680,
	"./FrmPurchaseEnquiry.js": 2424,
	"./FrmPurchaseIndent.js": 9847,
	"./FrmPurchaseQuotation.js": 5035,
	"./GRDSSettings.js": 4088,
	"./GRNCash.js": 8103,
	"./InsertCalculation.js": 415,
	"./InsertFRMS.js": 7316,
	"./InsertGRDS.js": 0,
	"./ModifyCalculation.js": 1122,
	"./ModifyFRMS.js": 5099,
	"./ModifyGRDS.js": 2919,
	"./PurchaseOrder.js": 8921,
	"./ServiceDashboard.js": 3322
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7043;